import { useEffect, useRef } from "react";

import { cn } from "@/lib/utils";

interface FormErrorProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Scrolls itself into view when it appears: forms submit from the sticky page
 * header, so the error can render far off screen from the button.
 */
export function FormError({ children, className }: FormErrorProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    ref.current?.scrollIntoView({ block: "nearest" });
  }, []);

  return (
    <div
      ref={ref}
      role="alert"
      className={cn(
        "scroll-mt-[calc(var(--top-bar-height,3.5rem)+3.5rem)] scroll-mb-6 rounded-md border border-destructive/20 bg-destructive/10 px-4 py-3 text-[13px] text-destructive",
        className
      )}
    >
      {children}
    </div>
  );
}
